<template>
  <div class="map-settings-view">

    <div class="setting-row">
      <span class="setting-label">Lock Map to north</span>
      <div class="form-check form-switch m-0">
        <input
          class="form-check-input setting-toggle"
          type="checkbox"
          role="switch"
          :checked="settings.lockToNorth"
          @change="onToggle('lockToNorth', $event)"
        />
      </div>
    </div>

    <div class="setting-row setting-row--nav" @click="$emit('navigate', 'mapProjection')">
      <span class="setting-label">Map projection</span>
      <span class="material-icons setting-chevron">chevron_right</span>
    </div>

    <div class="setting-row setting-row--nav" @click="$emit('navigate', 'mapElevation')">
      <span class="setting-label">3D Elevation Exaggeration</span>
      <span class="material-icons setting-chevron">chevron_right</span>
    </div>

    <button class="reset-btn mt-4" @click="resetToDefault">Reset to default</button>

  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {
  getMapSettings,
  saveMapSettings,
  applyMapSettings,
  DEFAULT_MAP_SETTINGS,
  MapSettings,
} from '../../../utils/mapSettings';

export default defineComponent({
  name: 'MapSettingsView',
  emits: ['navigate'],

  props: {
    mapInstanceName: { type: String, default: 'map' },
  },

  data() {
    return {
      settings: getMapSettings(),
    };
  },

  methods: {
    getMap(): any {
      return (window as Record<string, any>)[this.mapInstanceName] || null;
    },

    onToggle(key: 'lockToNorth', e: Event) {
      this.settings[key] = (e.target as HTMLInputElement).checked;
      saveMapSettings(this.settings);
      const map = this.getMap();
      if (map) applyMapSettings(map, this.settings);
    },

    resetToDefault() {
      this.settings.lockToNorth = DEFAULT_MAP_SETTINGS.lockToNorth;
      saveMapSettings(this.settings);
      const map = this.getMap();
      if (map) applyMapSettings(map, this.settings);
    },
  },
});
</script>

<style scoped>
.map-settings-view {
  padding: 0 0 24px;
}

.setting-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #2e2e2e;
}

.setting-row--nav {
  cursor: pointer;
  transition: background 0.15s;
}

.setting-row--nav:hover {
  background: rgba(255, 255, 255, 0.04);
}

.setting-label {
  font-size: 0.95rem;
}

.setting-chevron {
  color: #555;
}

.setting-toggle {
  width: 3em !important;
  height: 1.5em !important;
  background-color: #444 !important;
  border-color: #555 !important;
  cursor: pointer;
}

.setting-toggle:checked {
  background-color: #fddf00 !important;
  border-color: #fddf00 !important;
}

.reset-btn {
  display: block;
  width: calc(100% - 40px);
  margin: 0 20px;
  padding: 12px;
  background: #2d2d2d;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}

.reset-btn:hover {
  background: #3a3a3a;
}
</style>
